export default {
  path: "/pagesLegalService",
  name: "pagesLegalService",
  component: () => import("./index"),
  redirect: "/pagesLegalService/pagesLegalServiceIndex",
  children: [
    {
      path: "pagesLegalServiceIndex",
      name: "首页",
      component: () => import("./pagesLegalServiceIndex")
    },
    {
      path: "judicialCase/judicialCaseIndex",
      name: "司法行政案例",
      component: () => import("./judicialCase/judicialCaseIndex")
    }
    ,
    
    
    {
      path: "judicialCase/judicialCaseList",
      name: "司法行政案例",
      component: () => import("./judicialCase/judicialCaseList")
    }
    ,
    {
      path: "judicialCase/judicialCaseDetail",
      name: "司法行政案例",
      component: () => import("./judicialCase/judicialCaseDetail")
    },
    {
      path: "ImpartialService/list",
      name: "公证服务",
      component: () => import("./ImpartialService/list")
    },
    {
      path: "ImpartialService/deptDetail",
      name: "公证服务机构详情",
      component: () => import("./ImpartialService/deptDetail")
    },
    {
      path: "ImpartialService/userDetail",
      name: "公证服务人员详情",
      component: () => import("./ImpartialService/userDetail")
    },
    {
      path: "judicialExpertiseService/list",
      name: "司法鉴定",
      component: () => import("./judicialExpertiseService/list")
    },
    {
      path: "judicialExpertiseService/deptDetail",
      name: "司法鉴定机构",
      component: () => import("./judicialExpertiseService/deptDetail")
    },
    {
      path: "judicialExpertiseService/userDetail",
      name: "司法鉴定人员",
      
      component: () => import("./judicialExpertiseService/userDetail")
    },
    {
      path: "basicLevelService/list",
      name: "基层法律服务",
      component: () => import("./basicLevelService/list")
    },
    {
      path: "basicLevelService/deptDetail",
      name: "基层法律服务机构",
      component: () => import("./basicLevelService/deptDetail")
    },
    {
      path: "basicLevelService/userDetail",
      name: "基层法律服务人员",
      component: () => import("./basicLevelService/userDetail")
    },
    {
      path: "peoplesMediation/list",
      name: "人民调解",
      component: () => import("./peoplesMediation/list")
    },
    {
      path: "peoplesMediation/deptDetail",
      name: "人民调解机构",
      component: () => import("./peoplesMediation/deptDetail")
    },
    {
      path: "peoplesMediation/userDetail",
      name: "人民调解人员",
      component: () => import("./peoplesMediation/userDetail")
    },
    {
      path: "legalAid/list",
      name: "法律援助",
      component: () => import("./legalAid/list")
    },
    {
      path: "legalAid/deptDetail",
      name: "法律援助",
      component: () => import("./legalAid/deptDetail")
    },
    {
      path: "legalAid/deptDetail",
      name: "法律援助",
      component: () => import("./legalAid/deptDetail")
    },
    {
      path: "arbitrationService/list",
      name: "仲裁服务",
      component: () => import("./arbitrationService/list")
    },
    {
      path: "arbitrationService/deptDetail",
      name: "仲裁机构",
      component: () => import("./arbitrationService/deptDetail")
    },
    
    {
      path: "arbitrationService/userDetail",
      name: "仲裁人员",
      component: () => import("./arbitrationService/userDetail")
    },

    {
      path: "attorneyService/list",
      name: "律师服务",
      component: () => import("./attorneyService/list")
    },
    {
      path: "attorneyService/deptDetail",
      name: "律师服务机构",
      component: () => import("./attorneyService/deptDetail")
    },
    {
      path: "attorneyService/userDetail",
      name: "律师服务人员",
      component: () => import("./attorneyService/userDetail")
    },
    {
      path: "lawDatabase/lawDatabase",
      name: "法律法规数据库",
      component: () => import("./lawDatabase/lawDatabase")
    },
    {
      path: "lawDatabase/lawDatabaseDetail",
      name: "法律法规数据库详情",
      component: () => import("./lawDatabase/lawDatabaseDetail")
    },
  
    {
      path: "publicity/index",
      name: "法治宣传",
      component: () => import("./publicity/index")
    }
    ,
  
    {
      path: "publicity/list",
      name: "法治宣传",
      component: () => import("./publicity/list")
    }
    ,
    {
      path: "publicity/detail",
      name: "法治宣传",
      component: () => import("./publicity/detail")
    }
    ,
    {
      path: "announcementDetail",
      name: "新闻",
      component: () => import("./componts/announcementDetail")
    }
  ]
};



// WEBPACK FOOTER //
// ./src/views/pagesLegalService/router.js